import { render, staticRenderFns } from "./customerPrompt.vue?vue&type=template&id=445f3f6a&scoped=true&"
import script from "./customerPrompt.vue?vue&type=script&lang=js&"
export * from "./customerPrompt.vue?vue&type=script&lang=js&"
import style0 from "./customerPrompt.vue?vue&type=style&index=0&id=445f3f6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445f3f6a",
  null
  
)

export default component.exports